import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const SettingsContext = createContext(null);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    site_name: 'Fuwali Investments Zambia Limited',
    site_tagline: 'Diversified Investment Holding Company',
    logo_url: '/images/logo.svg',
    favicon_url: '/images/favicon.ico',
    footer_email: 'info@fuwaliinvestments.com',
    footer_phone: '+260 XXX XXX XXX',
    footer_address: 'Lusaka, Zambia',
    footer_copyright: '© 2024 Fuwali Investments Zambia Limited. All rights reserved.',
    social_linkedin: '',
    social_twitter: '',
    social_facebook: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get('/settings');
      setSettings(prev => ({ ...prev, ...response.data }));
    } catch (error) {
      console.error('Failed to fetch settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateSettings = async (newSettings) => {
    const response = await api.put('/settings', { settings: newSettings });
    setSettings(prev => ({ ...prev, ...newSettings }));
    return response.data;
  };

  const value = {
    settings,
    loading,
    updateSettings,
    refreshSettings: fetchSettings
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
